// Pure aggregation of a customer's complaint tickets (for the profile panel).
// No Firebase. `tickets` is the list already filtered to one customer's mobile.
import { categoryForIssue, CATEGORIES } from '../constants';

const NINETY_DAYS = 90 * 24 * 60 * 60 * 1000;
const isClosed = (t) => t.status === 'closed' || t.status === 'resolved';

export const summarizeCustomerComplaints = (tickets = []) => {
    const counts = {
        total: tickets.length,
        open: 0, closed: 0, doctor: 0, delivery: 0, refundReplacement: 0,
    };
    for (const t of tickets) {
        if (isClosed(t)) counts.closed++; else counts.open++;
        const cat = categoryForIssue(t.issueType);
        if (cat === CATEGORIES.PRODUCT) counts.doctor++;
        if (cat === CATEGORIES.DELIVERY) counts.delivery++;
        if (cat === CATEGORIES.REFUND || cat === CATEGORIES.REPLACEMENT) counts.refundReplacement++;
    }
    return counts;
};

// Has the same issue type recurred within 90 days?
const sameIssueWithin90 = (tickets) => {
    const byIssue = {};
    for (const t of tickets) {
        (byIssue[t.issueType] = byIssue[t.issueType] || []).push(t.createdAt || 0);
    }
    return Object.values(byIssue).some(times => {
        if (times.length < 2) return false;
        const sorted = [...times].sort((a, b) => a - b);
        for (let i = 1; i < sorted.length; i++) {
            if (sorted[i] - sorted[i - 1] <= NINETY_DAYS) return true;
        }
        return false;
    });
};

// Same product (or batch) across 2+ tickets?
const sameProductRepeated = (tickets) => {
    const seen = {};
    for (const t of tickets) {
        const keys = [...(t.productNames || []), ...(t.productIds || [])];
        if (t.doctorCase?.batchNumber) keys.push(`batch:${t.doctorCase.batchNumber}`);
        for (const k of keys) {
            seen[k] = (seen[k] || 0) + 1;
            if (seen[k] >= 2) return true;
        }
    }
    return false;
};

export const customerComplaintWarnings = (tickets = []) => {
    const warnings = [];
    if (tickets.length >= 2) warnings.push('Repeat complaint customer (2+ complaints)');
    if (tickets.some(t => ['Product Reaction', 'Burning Sensation'].includes(t.issueType) || categoryForIssue(t.issueType) === CATEGORIES.PRODUCT))
        warnings.push('Has doctor / product reaction complaint');
    if (tickets.some(t => [CATEGORIES.REFUND, CATEGORIES.REPLACEMENT].includes(categoryForIssue(t.issueType))))
        warnings.push('Has refund / replacement complaint');
    if (sameIssueWithin90(tickets)) warnings.push('Same issue repeated within 90 days');
    if (sameProductRepeated(tickets)) warnings.push('Complaint on same product / batch');
    return warnings;
};
